module.exports = __webpack_public_path__ + "static/Da Lopez-8c208c67786055f6875cfe287dfee25f.png";